export { default as CustomerOrderSetting } from './customer-setting'